















































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { Inject } from '@cds/common';
import VueUeditorWrap from "vue-ueditor-wrap";
import { NuoxiaoerService } from '@/services/nuoxiaoer-service';
import { ElForm } from 'element-ui/types/form';

@Component({
  components: {
    VueUeditorWrap,
  }
})
export default class FeedbackReplyPopup extends Vue {
  @Inject(NuoxiaoerService) private nuoxiaoerService!: NuoxiaoerService;

  @Emit('saved')
  private async emitSaved(): Promise<void> {
    // 保存成功后触发
  }

  @Emit('cancel')
  private async emitCancel(): Promise<void> {
    // 取消操作后触发
  }

  @Prop() private feedbackData!: any;
  @Prop({ default: false }) private isEdit!: boolean;

  @Watch('feedbackData', { immediate: true, deep: true })
  public onChangeFeedbackData(newVal: any) {
    if (newVal) {
      this.formData = {
        feedbackId: newVal.feedbackId || newVal.uuid,
        name: newVal.name || '',
        email: newVal.email || '',
        conditions: newVal.conditions || '',
        source: newVal.source || '--',
        description: newVal.description || '',
        imgUrls: newVal.imgUrls ? (Array.isArray(newVal.imgUrls) ? newVal.imgUrls : [newVal.imgUrls]) : [],
        replyContent: newVal.reply || '',
      };
    }
  }

  // 表单数据 - 改为与其他组件一致的命名
  public formData: any = {
    feedbackId: '',
    name: '',
    email: '',
    conditions: '',
    source: '',
    description: '',
    imgUrls: [],
    replyContent: '',
  };

  // 表单验证规则
  public rules: any = {
    replyContent: [
      { required: true, message: '请输入回复内容', trigger: 'blur' }
    ],
  };

  // UEditor配置
  public myConfig: any = {
    // 编辑器不自动被内容撑高
    autoHeightEnabled: false,
    // 初始容器高度
    initialFrameHeight: 400,
    // 初始容器宽度
    initialFrameWidth: '100%',
    // 上传文件接口
    serverUrl: '/api/application/ueditor/config',
    // UEditor 资源文件的存放路径
    UEDITOR_HOME_URL: '/ueditor/',
    toolbars: [[
      'fullscreen', 'source', '|', 'undo', 'redo', 'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript',
      'removeformat', 'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', 'forecolor',
      'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc',
      'fontfamily', 'fontsize', 'simpleupload', 'insertimage', 'emotion',
      'insertvideo', 'insertaudio', 'attachment', 'map',
      'rowspacingtop', 'rowspacingbottom', 'lineheight', 'link', 'unlink'
    ]],
    'fontfamily': [
      { label: '', name: 'songti', val: '宋体,SimSun' },
      { label: '仿宋', name: 'fangsong', val: '仿宋,FangSong' },
      { label: '仿宋_GB2312', name: 'fangsong', val: '仿宋_GB2312,FangSong' },
      { label: '', name: 'kaiti', val: '楷体,楷体_GB2312, SimKai' },
      { label: '', name: 'yahei', val: '微软雅黑,Microsoft YaHei' },
      { label: '', name: 'heiti', val: '黑体, SimHei' },
      { label: '', name: 'lishu', val: '隶书, SimLi' },
      { label: '', name: 'andaleMono', val: 'andale mono' },
      { label: '', name: 'arial', val: 'arial, helvetica,sans-serif' },
      { label: '', name: 'arialBlack', val: 'arial black,avant garde' },
      { label: '', name: 'comicSansMs', val: 'comic sans ms' },
      { label: '', name: 'impact', val: 'impact,chicago' },
      { label: '', name: 'timesNewRoman', val: 'times new roman' }
    ],
    elementPathEnabled: false, // 是否启用元素路径
    wordCount: false, // 是否开启字数统计
  };

  // 提交回复
  public submitReply(): void {
    (this.$refs.feedbackForm as ElForm).validate(async (isValid: boolean, invalidFields: any) => {
      if (!isValid) {
        console.log('表单验证失败', invalidFields);
        return false;
      }

      try {
        await this.$confirm('是否确认回复？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'info'
        });

        const params = {
          feedbackId: this.formData.feedbackId,
          description: this.formData.replyContent
        };

        await this.nuoxiaoerService.replyFeedback(params);
        this.$message({ message: '回复成功', type: 'success' });
        this.emitSaved();
      } catch (error) {
        if (error === 'cancel') {
          return;
        }
        console.error('回复失败：', error);
        this.$message.error('回复失败：' + ((error as any).message || '未知错误'));
      }
    });
  }

  // 提交更新（编辑模式-保存）
  public submitUpdate(): void {
    (this.$refs.feedbackForm as ElForm).validate(async (isValid: boolean, invalidFields: any) => {
      if (!isValid) {
        console.log('表单验证失败', invalidFields);
        return false;
      }

      try {
        await this.$confirm('是否确认修改？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'info'
        });

        const params = {
          feedbackId: this.formData.feedbackId,
          description: this.formData.replyContent
        };

        await this.nuoxiaoerService.replyFeedback(params);
        this.$message({ message: '修改成功', type: 'success' });
        this.emitSaved();
      } catch (error) {
        if (error === 'cancel') {
          return;
        }
        console.error('修改失败：', error);
        this.$message.error('修改失败：' + ((error as any).message || '未知错误'));
      }
    });
  }

  // 提交更新并通知用户（编辑模式-保存并通知用户）
  public submitUpdateAndNotify(): void {
    (this.$refs.feedbackForm as ElForm).validate(async (isValid: boolean, invalidFields: any) => {
      if (!isValid) {
        console.log('表单验证失败', invalidFields);
        return false;
      }

      try {
        await this.$confirm('是否确认修改并通知用户？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'info'
        });

        const params = {
          feedbackId: this.formData.feedbackId,
          description: this.formData.replyContent
        };

        await this.nuoxiaoerService.saveAndNotifyFeedbackReply(params);
        this.$message({ message: '修改成功并已通知用户', type: 'success' });
        this.emitSaved();
      } catch (error) {
        if (error === 'cancel') {
          return;
        }
        console.error('修改并通知失败：', error);
        this.$message.error('修改并通知失败：' + ((error as any).message || '未知错误'));
      }
    });
  }

  // 取消按钮
  public async handleCancel(): Promise<void> {
    try {
      await this.$confirm('是否关闭当前界面？关闭后，当前界面内容将会丢失', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      });
      this.emitCancel();
    } catch (error) {
      // 用户取消操作，不做处理
    }
  }
}
